import {
  AdminRole, ProviderMedicalRole, SexEnum, SubSystem, UserRole, UserRules, UserStatus
} from '@uplift/types';

import { Address } from './common';

export type User = {
  id: string;
  email: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  preferredName?: string;
  role: UserRole;
  adminRole: AdminRole | null;
  status: UserStatus;
  active: boolean;
  lastLogin: string;
  medicalRole: ProviderMedicalRole | null;
  emailVerified: boolean;
  isInvited?: boolean;
  createdAt: string;
  updatedAt: string;
  dob?: string | null;
  subsystem: SubSystem | null;
};

export const enum UserPrefix {
  dr = 'Dr.'
}

export enum UserContactPreferenceEnum {
  text = 'text',
  phone = 'phone',
}

export enum UserSuffix {
  ABPP = 'ABPP',
  DO = 'DO',
  EdD = 'EdD',
  LCADAC = 'LCADAC',
  LCMFT_LIMFT = 'LCMFT LIMFT',
  LCPC = 'LCPC',
  LCSW = 'LCSW',
  LCSW_C = 'LCSW-C',
  LICSW = 'LICSW',
  LISW = 'LISW',
  LMFT = 'LMFT',
  LMHC_LCMHC = 'LMHC LCMHC',
  LMHP = 'LMHP',
  LPC = 'LPC',
  LPCC = 'LPCC',
  LPMHC = 'LPMHC',
  MD = 'MD',
  PA_C = 'PA-C',
  PhD = 'PhD',
  PMHNP = 'PMHNP',
  PsyD = 'PsyD'
}

export type UserProfile = {
  id: string;
  userId: string;
  preferredName: string;
  pronouns?: string;
  sex: SexEnum;
  dob: string;
  timezone: string;
  address: Address;
  prefix: UserPrefix | null;
  suffixes: UserSuffix[];
  avatarAssetId?: string;
  createdAt: string;
  updatedAt: string;

  shortBio?: string;
  ethnicity?: string;
  contactPreference?: UserContactPreferenceEnum;
  title?: string;

};

export type PublicUserProfile = Pick<UserProfile,
| 'id'
| 'userId'
| 'timezone'
| 'title'
| 'contactPreference'
| 'pronouns'
| 'preferredName'
| 'sex'
| 'avatarAssetId'
| 'prefix'
| 'suffixes'
| 'shortBio'
>;

export type UserWithProfile = {
  user: User;
  profile: UserProfile;
};

export type LegacyUserWithProfile = User & {
  userProfile?: Partial<UserProfile>;
};

export const isUserHigherEdStudent = (user: User): boolean => user.role === UserRole.patient && user.subsystem === SubSystem.higherEd;


export type CurrentUser = {
  id: string;
  role: UserRole;
  adminRole?: AdminRole;
  firstName: string;
  middleName?: string;
  lastName: string;
  status: UserStatus | string;
  email: string;
  timezone?: string;
  medicalRole?: ProviderMedicalRole;
  preferredName?: string;
  avatarSrc?: string;
  fullTime?: boolean;
  rules?: UserRules;
  isLoading: boolean;
  isImpersonated?: boolean;
  subsystem?: SubSystem | null;
};
